// vista para registrar un usuario

import { useState } from "react";

// api urls imports
import { urls } from "../../api-urls/api-urls.js";

// import app config
import { LANGUAGE } from "../../config/appConf.js";

// import react translation
import { useTranslation } from "react-i18next";




export const SignUpForm = () => {

  // GET the react translation
  const [t] = useTranslation("global");

  // state definition
  const [stateForm, setStateForm] = useState({ nombre: "", email: "", contrase: "", repContra: "", timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
  const [listRequ, setListRequ] = useState({ longCara: false, minuscu: false, mayuscu: false, caracSpec: false, num: false, email: true, validAll: false });
  const [state, setState] = useState({ isLoading: false, showMsg: true, msg: "" });


  const VALID_INPUTS = listRequ.longCara && listRequ.minuscu && listRequ.mayuscu && listRequ.caracSpec && listRequ.num && listRequ.email && stateForm.contrase.trim() === stateForm.repContra.trim();

  // console.log(VALID_INPUTS)


  // funcion para validar si es email
  const onHandleValEmail = () => {
    const isEmail = /^[\w-]+(\.[\w-]+)*@[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/.test(stateForm.email);
    if (isEmail) {
      setListRequ((val) => ({ ...val, email: true }));
    } else {
      setListRequ((val) => ({ ...val, email: false }));
    }
  };


  // funcion para verificar el password
  const onHandleChangePassw = (newVal = "") => {
    // expresiones regulares
    const hasUpperCase = /[A-Z]/.test(newVal);
    const hasLowerCase = /[a-z]/.test(newVal);
    const hasNumber = /[0-9]/.test(newVal);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newVal);
    const hasMinLength = newVal.length >= 8;

    if (hasMinLength) {
      setListRequ((val) => ({ ...val, longCara: true }));
    } else {
      setListRequ((val) => ({ ...val, longCara: false }));
    }

    if (hasLowerCase) {
      setListRequ((val) => ({ ...val, minuscu: true }));
    } else {
      setListRequ((val) => ({ ...val, minuscu: false }));
    }

    if (hasUpperCase) {
      setListRequ((val) => ({ ...val, mayuscu: true }));
    } else {
      setListRequ((val) => ({ ...val, mayuscu: false }));
    }

    if (hasSpecialChar) {
      setListRequ((val) => ({ ...val, caracSpec: true }));
    } else {
      setListRequ((val) => ({ ...val, caracSpec: false }));
    }

    if (hasNumber) {
      setListRequ((val) => ({ ...val, num: true }));
    } else {
      setListRequ((val) => ({ ...val, num: false }));
    }

    // if (hasLowerCase) {}
    setStateForm((val) => ({ ...val, contrase: newVal }));
  };


  // funcion para enviar el formulario al servidor
  const onHandleSubmitForm = async (event) => {
    event.preventDefault();

    const END_POINT = `${urls.signUp}?language=${LANGUAGE}`;

    if (!listRequ.longCara && !listRequ.minuscu && !listRequ.mayuscu && !listRequ.caracSpec && !listRequ.num && !listRequ.email) {
      return setListRequ((val) => ({ ...val, validAll: true }));
    }

    try {
      setState((val) => ({ ...val, isLoading: true }));
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(stateForm)
      });

      const data = await response.json();

      if (response.status === 200) {
        setState((val) => ({ ...val, showMsg: data?.msg, msg: data?.msg }));
        setStateForm((val) => ({ ...val, nombre: "", email: "", contrase: "", repContra: "" }));
      } else if (response.status === 404) {
        setState((val) => ({ ...val, showMsg: true, msg: data?.msg }));
      } else if (response.status === 400) {
        setState((val) => ({ ...val, showMsg: true, msg: data?.msg }));
      }

      setState((val) => ({ ...val, isLoading: false }));

    } catch (error) {
      console.log(error);
    }
  };




  return (
    <div className="container-parent-sign-up">
      {
        state.showMsg && state.msg && (
          <div className="msg-notifi-secur">
            <div>
              <strong style={{ color: "rgba(224,28,28,0.788)" }}>{state.msg}</strong>
            </div>
            <div>
              <button className="btn-close-log" onClick={() => setState((val) => ({ ...val, showMsg: false, msg: "" }))}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                </svg>
              </button>
            </div>
          </div>
        )
      }
      <h2 style={{ color: "var(--white-color)" }}>Sign up</h2>
      <form onSubmit={onHandleSubmitForm} className="container-sign-up">
        <div className="row-flex">
          <div className="col-4">
            <strong>{t("SignUpComp.nombre")}</strong>
          </div>
          <div className="col-75">
            <input
              className="input-control-text"
              type="text"
              name="fullName"
              value={stateForm.nombre}
              onChange={({ target }) => setStateForm((val) => ({ ...val, nombre: target.value }))}
              autoComplete="off" />
          </div>
        </div>
        <div className="row-flex">
          <div className="col-4">
            <strong>{t("SignUpComp.correo")}</strong>
          </div>
          <div className="col-75">
            <input
              className="input-control-text"
              type="text"
              name="email"
              value={stateForm.email}
              onChange={({ target }) => setStateForm((val) => ({ ...val, email: target.value }))}
              onBlur={onHandleValEmail}
              autoComplete="off"
              required />
            {
              !listRequ.email && (<p style={{ margin: 0, padding: 0 }}><small className="invalid fade-animation">Este correo no es válido</small></p>)
            }
          </div>
        </div>
        <div className="row-flex">
          <div className="col-4">
            <strong>{t("SignUpComp.contra")}</strong>
          </div>
          <div className="col-43">
            <input
              className="input-control-text"
              type="password"
              name="passW"
              value={stateForm.contrase}
              onChange={({ target }) => onHandleChangePassw(target.value)}
              autoComplete="off" />
          </div>
        </div>
        <div className="row-flex">
          <div className="col-4">
            <strong>{t("SignUpComp.rep_contra")}</strong>
          </div>
          <div className="col-43">
            <input
              className="input-control-text"
              type="password"
              name="passWR"
              value={stateForm.repContra}
              onChange={({ target }) => setStateForm((val) => ({ ...val, repContra: target.value }))}
              autoComplete="off" />
          </div>
          <div className="flex-grow-1">
            {
              stateForm.contrase.trim() !== stateForm.repContra.trim() && (<small className="invalid fade-animation">{t("SignUpComp.no_coinciden")}</small>)
            }
          </div>
        </div>
        <div className="">
          <p style={{ padding: 0 }}>
            <small>{t("SignUpComp.debe_conte")}</small>
          </p>
          <ul className="list-required">
            <li className={listRequ.longCara ? "valid-passw" : "invalid"}>{t("SignUpComp.8_caract")}</li>
            <li className={listRequ.minuscu ? "valid-passw" : "invalid"}>{t("SignUpComp.al_menos_min")}</li>
            <li className={listRequ.mayuscu ? "valid-passw" : "invalid"}>{t("SignUpComp.al_menos_min")}</li>
            <li className={listRequ.caracSpec ? "valid-passw" : "invalid"}>{t("SignUpComp.al_menos_un_carac")}</li>
            <li className={listRequ.num ? "valid-passw" : "invalid"}>{t("SignUpComp.al_menos_un_nume")}</li>
          </ul>
        </div>
        {
          listRequ.validAll && (
            <p><small className="invalid">{t("SignUpComp.debe_llenar_todo")}</small></p>
          )
        }
        <button type="submit" disabled={!VALID_INPUTS || state.isLoading} className={VALID_INPUTS ? "btn-continue" : "btn-cont-not-allw"}>{state.isLoading ? t("SignUpComp.cargando") : t("SignUpComp.continuar")}</button>
      </form>
    </div>
  );
};